import React, { useState, useEffect } from 'react';
import 'date-fns';
import moment from 'moment';

/** Plugins */
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, Button, TextField, Select, MenuItem } from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/moment';

/** Helpers */
import Languages from '../../constants/languages';

const AdminModal = ({ columns, data, modalName, onSubmit, onClose, isUpdating = false }) => {
  const getColumns = () => {
    let defaultValues = {};
    columns.forEach(column => {
      defaultValues = { ...defaultValues, [column.prop]: column.defaultValue || '' };
    });
    return defaultValues;
  };
  const [formData, setFormData] = useState(getColumns());
  const [updatedValue, setUpdatedValue] = useState(+new Date());
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [selectedFile, setSelectedFile] = useState();

  useEffect(() => {
    if (isUpdating) setFormData(data);
  }, [isUpdating]);

  const getI18nValue = (code, prop) => {
    return formData.i18n ? formData.i18n[code][prop] : formData.i18nContent[code][prop];
  };

  /**
   * Change form data on change form values
   *
   * @param {Event} e - onChange event
   * @param {String} code - i18n language type (en, es, pt)
   * @param {String} label - input labe;
   */
  const handleOnChageTextField = (e, code, label) => {
    let aux = formData;
    if (formData.i18n) {
      aux['i18n'][code][label] = e.target.value;
    } else if (formData.i18nContent) {
      aux['i18nContent'][code][label] = e.target.value;
    }
    setFormData(aux);
    setUpdatedValue(+new Date());
  };

  const hanldeChangeFile = e => {
    setFormData({ ...formData, [e.target.name]: e.target.files[0] });
    setIsFilePicked(true);
    setSelectedFile(e.target.files[0]);
  };

  return (
    <div className="modal-container-full">
      <div className="modal-container-full__top">
        <h2>{modalName}</h2>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <div div className="modal-container-full__body">
        <div>
          <form noValidate autoComplete="off">
            <div>
              {columns.map(column => {
                switch (column.type) {
                  case 'text':
                  case 'number':
                    if (column.prop === 'sqlCheck' || column.prop === 'sqlCheckProgress') {
                      return (
                        <TextField
                          id="standard-basic"
                          label={`${column.label} `}
                          value={formData ? formData[column.prop] : ''}
                          defaultValue={column.defaultValue || ''}
                          onChange={e => setFormData({ ...formData, [column.prop]: e.target.value })}
                          required={column.required}
                          disabled={column.disabled}
                          variant="outlined"
                          multiline
                          rows={5}
                        />
                      );
                    } else {
                      return (
                        <TextField
                          id="standard-basic"
                          label={`${column.label} `}
                          value={formData ? formData[column.prop] : ''}
                          defaultValue={column.defaultValue || ''}
                          onChange={e => setFormData({ ...formData, [column.prop]: e.target.value })}
                          required={column.required}
                          disabled={column.disabled}
                        />
                      );
                    }
                    break;
                  case 'date':
                    return (
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePicker
                          autoOk={true}
                          disableFuture={column.disableFuture}
                          disablePast={column.disablePast}
                          variant={'inline'}
                          label={`${column.label} `}
                          defaultValue={column.defaultValue || moment(formData[column.prop]).toDate() || moment().toDate()}
                          value={moment(formData[column.prop]).toDate()}
                          onChange={newValue => setFormData({ ...formData, [column.prop]: newValue })}
                          required={column.required}
                        />
                      </MuiPickersUtilsProvider>
                    );
                  case 'i18':
                    return Languages.map(({ code }) => (
                      <>
                        {typeof column.defaultValue === 'object' ? (
                          Object.keys(formData.i18n ? formData.i18n[code] : formData.i18nContent[code]).map(label => {
                            if (label === 'description' || label === 'rules')
                              return (
                                <TextField
                                  multiline
                                  rows={6}
                                  variant="outlined"
                                  key={label}
                                  id="standard-basic"
                                  className="modal-container-full__body__text-area"
                                  value={updatedValue && getI18nValue(code, label)}
                                  label={`${label.charAt(0).toUpperCase() + label.slice(1)} in ${code}`}
                                  required={column.required}
                                  onChange={e => handleOnChageTextField(e, code, label)}
                                />
                              );

                            return (
                              <TextField
                                key={label}
                                id="standard-basic"
                                value={updatedValue && getI18nValue(code, label)}
                                label={`${label.charAt(0).toUpperCase() + label.slice(1)} in ${code}`}
                                required={column.required}
                                onChange={e => handleOnChageTextField(e, code, label)}
                              />
                            );
                          })
                        ) : (
                          <TextField
                            multiline
                            key={code}
                            id="standard-basic"
                            value={formData && formData.i18n ? formData.i18n[code] : ''}
                            label={`Name in ${code}`}
                            required={column.required}
                            onChange={e =>
                              setFormData({
                                ...formData,
                                i18n: {
                                  ...formData.i18n,
                                  [code]: e.target.value,
                                },
                              })
                            }
                          />
                        )}
                      </>
                    ));
                  case 'select':
                    return (
                      <Select
                        label={`${column.label} `}
                        className="select-input"
                        value={formData ? formData[column.prop] : ''}
                        onChange={e => setFormData({ ...formData, [column.prop]: e.target.value })}
                        required={column.required}
                        disabled={column.disabled}
                      >
                        {column.options.map(option => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    );

                  case 'file':
                    return (
                      <div className="send-template__file">
                        <label className="bp3-file-input bp3-fill">
                          <input type="file" name="file" accept=".html" onChange={hanldeChangeFile} />
                          {isFilePicked ? (
                            <div className="send-template__file__name">
                              <p>File name: {selectedFile.name}</p>
                              <p>File type: {selectedFile.type}</p>
                            </div>
                          ) : (
                            <span className="bp3-file-upload-input">Import HTML Custom Template </span>
                          )}
                        </label>
                      </div>
                    );
                  default:
                    return <></>;
                }
              })}
            </div>
          </form>
        </div>
      </div>
      <Button onClick={() => onSubmit(formData)} variant="contained" className="modal__btn">
        Confirm
      </Button>
    </div>
  );
};
export default AdminModal;
